module.exports = __webpack_public_path__ + "static/media/inbox-task.9927a303.png";